/**
 * Builds the sign-in URL, omitting a `returnTo` that says nothing.
 *
 * `/` is where sign-in lands when no destination is carried, on both sides: the
 * login page defaults to it and so does the API's `/auth/login`. Spelling it out
 * as `?returnTo=%2F` therefore changes no behaviour — it only puts an encoded
 * slash in the address bar of the most-visited URL in the app.
 *
 * A real destination is still carried, because S02 asks for it ("a failed
 * refresh re-authenticates and preserves the destination").
 */
export const LOGIN_ROUTE = '/login';

/** The API endpoint that starts the OIDC flow. Same rule, different base. */
export const LOGIN_START = '/api/auth/login';

export function loginPath(returnTo: string, base: string = LOGIN_ROUTE): string {
  return isDefaultDestination(returnTo) ? base : `${base}?returnTo=${encodeURIComponent(returnTo)}`;
}

/**
 * True when `returnTo` would land the user exactly where the default already
 * lands them. An empty string counts: `location.pathname` is never empty in a
 * browser, but a caller composing one from parts can produce it.
 */
export function isDefaultDestination(returnTo: string): boolean {
  return returnTo === '' || returnTo === '/';
}
